import { IsArray, IsIn, IsInt, IsOptional } from 'class-validator';
import { OrderHistoryPaymentStatusEnum } from '../../enum';

export class SearchOrderHistoryRequestDto {
  @IsOptional()
  @IsArray()
  @IsInt({ each: true })
  merchantIdList: number[];

  @IsOptional()
  @IsIn(Object.values(OrderHistoryPaymentStatusEnum))
  paymentStatus: OrderHistoryPaymentStatusEnum;
}